import styled from 'styled-components';

import ModalContainer from '../../containers/ModalContainer';
import { Typography } from '../../../display/Typography';
import { MainButton } from '../../../inputs/buttons/MainButton';

// Cargando canónico (patrón ConfirmTransferModal/DeleteTeamModal/PauseTimer):
// overlay Loader absoluto + contenido atenuado mientras isLoading.
export const ModalContainerStyled = styled(ModalContainer)`
  position: relative;
`;

export const ContainerLoader = styled.div`
  position: absolute;
  top: 40%;
  left: 45%;
  z-index: 1;
`;

export const ContainerForm = styled.form<{ isLoading?: boolean }>`
  opacity: ${(props) => (props.isLoading ? 0.6 : 1)};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 2.5rem 6.35rem;
  width: 100%;
  max-height: 92vh;
  overflow-y: auto;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    padding: 2.5rem 2.4rem;
    gap: 2rem;
  }
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xs}rem;
`;

export const Text = styled(Typography)`
  text-align: center;
`;

export const Title = styled(Text)`
  font-size: 2.4rem;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spaces.xs}rem;
  width: 100%;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.m};
  width: 100%;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    /* Botones SIEMPRE en fila (uno al lado del otro), también en tablet/móvil:
       apilarlos en columna alargaba el modal y se cortaba en navegador (sin la
       barra extra de la PWA). En pantallas estrechas comparten el ancho.
       Misma pauta que ChangeDirectionModal (feedback usuario 2026-08-05). */
    & > * {
      flex: 1 1 0;
      min-width: 0;
    }
  }
`;

export const ActionButton = styled(MainButton)`
  min-width: 13.4rem;
  justify-content: center;

  /* Tablet/móvil: botones EN FILA compartiendo ancho (ver ButtonRow). Sin
     bajar este min-width no cabían dos y se apilaban → modal más alto. */
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    min-width: 0;
    flex: 1 1 0;
  }
`;
